import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAvergingPitotTube = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 50,
	viewBox: "0 0 50.0 50.0",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 0,
		y: 0,
		width: 50,
		height: 50,
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 25.0 0.0 L 25.0 35.0 L 10.0 35.0 M 25.0 20.0 L 10.0 20.0 M 25.0 30.0 L 10.0 30.0 M 25.0 25.0 L 10.0 25.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgAvergingPitotTube;
